var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.334 7.99669H3.99512V5.86247L10.6646 2.66113L17.334 5.86247V7.99669Z",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99512 16H13.3323",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.334 7.99669H3.99512V5.86247L10.6646 2.66113L17.334 5.86247V7.99669Z",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99512 16H13.3323",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32905 15.9999V7.99658",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33076 15.9999V7.99658",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3322 15.9999V7.99658",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6646 28.0051H6.2814C5.01954 28.0051 3.99512 26.9807 3.99512 25.7189V21.3357",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3357 5.32886H25.7189C26.9807 5.32886 28.0051 6.35328 28.0051 7.61514V11.9983",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.005 28.005L27.6262 27.054C27.4341 26.5724 27.1366 26.1389 26.7565 25.7868V25.7868C26.1122 25.1892 25.2652 24.8584 24.3875 24.8584H19.1533",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5593 16.2121C24.7318 17.3846 24.7318 19.2841 23.5593 20.4566C22.3869 21.6291 20.4874 21.6291 19.3149 20.4566C18.1424 19.2841 18.1424 17.3846 19.3149 16.2121C20.4874 15.0396 22.3869 15.0396 23.5593 16.2121",
    stroke: "#0FD08B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditProfile);
export default __webpack_public_path__ + "static/media/creditProfile.e5e641baea9f567e2d86e5f82920b6cc.svg";
export { ForwardRef as ReactComponent };